"use strict";
function Visitor() {}

Visitor.prototype = {
  constructor: Visitor,

  accept: function(object) {
    return this[object.type](object);
  }
};

exports["default"] = Visitor;


//////////////////
// WEBPACK FOOTER
// ./~/handlebars/dist/cjs/handlebars/compiler/visitor.js
// module id = 89
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21